import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyles } from "styles/GlobalStyles";
import { Provider } from "react-redux";
import { store } from "utils/@reduxjs/store";
import CustomToastContainer from "components/ToastContainer/index";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <GlobalStyles />
      <App />
      <CustomToastContainer />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
